<template>
  <div class="feed-item-small">
    <div class="card card-default mb-4">
      <div class="content">
        <div class="row">
          <div class="col-2 text-center">
            <img :src="icon" :alt="feedItem.reportType" class="img-thumbnail">
          </div>
          <div class="col-10">
            <span class="text-muted small">
              <i class="far fa-clock"></i> {{ feedItem.createdAt | date_time_format }}</span>
            <br/>
            <strong>{{ feedItem.StaffMember.fullName }}</strong> {{ feedItem.verb }} {{ article }} {{ feedItem.reportType }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'FeedItemDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    computed: {
      article () {
        if (['a', 'e', 'i', 'o', 'u'].includes(this.feedItem.reportType.toLowerCase().charAt(0))) {
          return 'an'
        }
        return 'a'
      },
      icon () {
        return 'https://s3-ap-southeast-2.amazonaws.com/roscon/' + this.feedItem.Application.AppIcon.objectKey
      },
      feedItem () {
        return {
          Application: {
            AppIcon: {}
          },
          ...this.object
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/FeedItemSmall.vue